@if (rowData$ | async; as rowData) {
  @for (column of rowDefDirective.rowDisplayColumns(); track trackByFn($index, column)) {
    @if (column | getCell; as cell) {
      <ng-container
        [ngTemplateOutlet]="cell.templateRef"
        [ngTemplateOutletContext]="{ $implicit: rowData, rowIndex: rowIndex }"
      />
    } @else {
      <!-- Keep the grid track of a column without a cell so the next cells stay under their headers -->
      <div></div>
    }
  }
}
